/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Modal } from 'fpay-ui';
import { useTranslation, Trans } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { FUNDS_OUT, SETTLEMENT_CALENDAR, LAST_MOVEMENTS } from '@constants/routes';

import {
  AmountCard,
  StyledTitle,
  LastMovements,
  TextModal,
  ButtonSeeAll,
  ErrorTableLastMovements,
  ModalToFsc,
  NotFoundLastMovements,
  AdvancementModal,
  ModalToRedirect,
  LayoutGral,
  TycWarning,
  BlockedSellerModal,
  ModalLastMovementsTable,
} from '@components';

import OperationTable from '@components/OperationTable';

import {
  useAuth,
  useAndes,
  usePromotions,
  useBlockings,
  useAdvancements,
  useSellerBlockModal,
} from '@hooks';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { moneyFormat } from '@helpers';
import useMovements from '@hooks/useMovements';

import { fetchAdvancementDetail } from '@store/advancements/actions';

import { TYPE_MOVEMENT_AUTHORIZATION } from '@constants/transactions';

import { getEnv } from '@config';
import HomeScreenSkeleton from './index.skeleton';

const Home = styled.div`
  padding: 0;
  padding-top: 8px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    padding-top: 16px;
  }

  ${({ theme }) => theme.newBreakpoint('md')} {
    white-space: pre-line;
  }

  button {
    margin-top: 12px;

    ${({ theme }) => theme.newBreakpoint('sm')} {
      margin-top: 16px;
    }

    ${({ theme }) => theme.newBreakpoint('md')} {
      margin-top: 16px;
    }
  }
`;

const HelloTitle = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  width: 100%;
  margin-top: -27px;
  justify-content: flex-start;
  margin-bottom: 27px;
`;

const Cards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 8px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
`;
const LayoutTable = styled.div`
  width: 100%;
  min-height: 250px;
`;

const TyCWarningContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 24px;
`;

const HomeScreen = () => {
  const {
    isAllowed,
    isTCMsg,
    merchant,
    isSeller,
    isLegalAgent,
    isOnus,
    isAlianza,
    isAlianzaMixto,
    isRL,
  } = useAuth();

  const { t } = useTranslation();
  const { getIdBackground, updateAdvancementStatus, displayBanners, occultBanners } =
    useAdvancements();

  const { isSkeleton, showBanners } = useSelector((state) => state.common) || true;
  const { enabledBlockingFundsOutForAll } = getEnv();

  const [showTycWarning, setShowTycWarning] = useState(false);
  const toggleTycWarning = () => {
    setShowTycWarning(!showTycWarning);
  };

  const [showModal, setShowModal] = useState(false);
  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const [showModalToRedirect, setShowModalToRedirect] = useState(false);
  const toggleShowModalToRedirect = () => {
    setShowModalToRedirect(!showModalToRedirect);
  };

  const [showTooltipModal, setShowTooltipModal] = useState(false);
  const toggleModal = () => {
    setShowTooltipModal(!showTooltipModal);
  };
  const [showTooltipModal2, setShowTooltipModal2] = useState(false);
  const toggleModal2 = () => {
    setShowTooltipModal2(!showTooltipModal2);
  };
  const [showTooltipModal3, setShowTooltipModal3] = useState(false);
  const toggleModal3 = () => {
    setShowTooltipModal3(!showTooltipModal3);
  };

  const [transactionIdToShow, setTransactionIdToShow] = useState();

  const [showModalPopUpTable, setShowModalPopUpTable] = useState(false);
  const [idToShow, setIdToShow] = useState();
  const toggleModalPopUpTable = () => {
    setIdToShow();
    setTransactionIdToShow();
    setShowModalPopUpTable(!showModalPopUpTable);
  };
  const [showAdvancementModal, setShowAdvancementModal] = useState(false);
  const toggleShowAdvancementModal = () => {
    updateAdvancementStatus();
    displayBanners();
    setShowAdvancementModal(!showAdvancementModal);
  };

  const displayAdvancementModal = () => {
    occultBanners();
    setShowAdvancementModal(true);
  };

  const isValidateTC = isTCMsg();
  useEffect(() => {
    !isValidateTC && setShowTycWarning(!isValidateTC);
    // eslint-disable-next-line
  }, []);

  const { breakpoint } = useBreakpoints();
  const [operationHeader] = useState(['FECHA', 'CODIGO', 'TIPO DE MOVIMIENTO', 'DETALLE', 'MONTO']);
  const { items, getMovements, errorLastMovements } = useMovements();

  const { getPromotionsBanner, getPromotions } = usePromotions();
  const { getBlockings, blockings } = useBlockings();
  const { showSellerBlockModal, toggleShowSellerBlockModal, setConfirmationBlockUnderstanding } =
    useSellerBlockModal(blockings);

  const { first_name } = useSelector((state) => state.login.loguedAs);

  const first = first_name.charAt(0).toUpperCase() + first_name.slice(1).toLowerCase();

  const {
    getBalances,
    availableIncome,
    errAllBalances,
    salesInProgress,
    errGsc,
    errMerchant,
    settledIncome,
    loadedAmounts,
  } = useAndes(undefined, false);
  const { avoidPromotionValidation } = getEnv();

  useEffect(() => {
    getMovements({});
    // eslint-disable-next-line
  }, [merchant]);

  useEffect(() => {
    getBalances();
  }, [merchant, getBalances]);

  const merchantId = merchant?.sellers?.[0]?.merchant_id;
  const creditorAccountId = merchant?.wallet_info?.creditor_account_id;

  const dispatch = useDispatch();

  useEffect(() => {
    if (idToShow) {
      setShowModalPopUpTable(true);

      if (idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS) {
        dispatch(fetchAdvancementDetail(merchantId, transactionIdToShow, creditorAccountId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToShow]);

  const blockingsAllowed =
    isAllowed('FINANCING_BLOCKINGS') && (enabledBlockingFundsOutForAll === 'true' || isSeller());

  useEffect(() => {
    if (blockingsAllowed) {
      getBlockings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchant, blockingsAllowed]);

  useEffect(() => {
    if (avoidPromotionValidation === 'false' && isRL() && isSeller()) {
      getPromotions();
    }
  }, [getPromotions]);

  useEffect(() => {
    displayBanners();
  }, []);

  const isBlocked = (action) => blockings.includes(action);

  const shouldShowAdvancementHelpLink = () =>
    settledIncome > 0 &&
    isSeller() &&
    isAllowed('EXECUTE_ADVANCEMENT') &&
    !isBlocked('ADVANCEMENT');

  const shouldShowPromotionsSection = () => isAllowed('PROMOTIONS');

  const isFondsOutEnabled = isAllowed('WITHDRAW');

  const setBankDescription = (foDate) => {
    const bank = merchant.bank_accounts.find(
      (b) =>
        b.hasOwnProperty('created_at') &&
        b.hasOwnProperty('updated_at') &&
        ((b.enabled && moment(foDate).isAfter(b.created_at)) ||
          (!b.enabled && moment(foDate).isBetween(b.created_at, b.updated_at)))
    );
    if (!bank) return t('lastMovements.fondsOut');
    const accountNumber = bank?.account_data?.account_number;
    const lastFourDigits = accountNumber && accountNumber.substring(accountNumber.length - 4);
    const accountBank = bank?.bank_data?.finantial_institution_name;
    const accountBankCap = _.startCase(_.camelCase(accountBank));
    return `${t('lastMovements.fondsOutTo')}${accountBankCap}${t(
      'lastMovements.points'
    )}${lastFourDigits}`;
  };

  const getFondsOutByAuthorization = ({ type, event_date_utc, soft_descriptor, entry_mode }) => {
    switch (type) {
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
        return t('lastMovements.payOrder');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
        return t('lastMovements.advancementsIn');
      case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO:
        return t('lastMovements.deferredTransfer');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
        return entry_mode
          ? t('lastMovements.creditLineCollection')
          : isAllowed('FOUNDS_BANK_VALIDATION')
          ? setBankDescription(event_date_utc)
          : t('lastMovements.fondsOut');
      case TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO:
        return t('lastMovements.regularizationAdjust');
      case TYPE_MOVEMENT_AUTHORIZATION.PAGO_DE_CUOTA_DE_CREDITO:
        return t('lastMovements.creditInstallmentPayment');
      case TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO:
        return t('lastMovements.creditInstallmentRefund');

      default:
        return soft_descriptor;
    }
  };

  return (
    <>
      {isSkeleton ? (
        <LayoutGral>
          <HomeScreenSkeleton />
        </LayoutGral>
      ) : (
        <LayoutGral>
          <Home>
            <HelloTitle>
              {t('headerDropdown.hello')} {first}!
            </HelloTitle>
            {isAllowed('FOUNDS_TC_ENABLED') && showTycWarning && !isLegalAgent() && (
              <TyCWarningContainer>
                <TycWarning closeWarning={toggleTycWarning} />
              </TyCWarningContainer>
            )}
            {shouldShowPromotionsSection() && showBanners && (
              <>
                {getPromotionsBanner(
                  {
                    showModalToRedirect: () => setShowModalToRedirect(true),
                    showModalAdvancement: () => displayAdvancementModal(),
                  },
                  t('homeScreen.homeScreenTitles.promociones')
                )}
              </>
            )}
            <StyledTitle>{t('homeScreen.homeScreenTitles.saldos')}</StyledTitle>
            <Cards>
              {isAllowed('SALES_IN_PROCESS_ENABLED') && (
                <AmountCard
                  htmlIdTooltip="home-tooltip-sales-in-process"
                  amount={isSeller() ? (errGsc ? 'error' : moneyFormat(salesInProgress, false)) : 0}
                  handleClick={() => setShowTooltipModal(true)}
                  handleClickLink={() => setShowModal(true)}
                  htmlIdLink="home-sales-in-process-see-detail"
                  link={t('homeScreen.salesCard.link')}
                  title={
                    isSeller()
                      ? t('homeScreen.salesCard.title')
                      : t('homeScreen.salesCard.titleMerchant')
                  }
                  tooltipText={
                    isSeller() || isAlianzaMixto() || salesInProgress === 0
                      ? t('tooltipCards.sellerHomeSalesInProgress')
                      : t('tooltipCards.merchantHomeSalesInProgress')
                  }
                  helpLink={
                    isSeller()
                      ? t('homeScreen.cards.startSellSeller')
                      : isOnus || isAlianza() || isAlianzaMixto()
                      ? t('homeScreen.cards.startSellMix')
                      : t('homeScreen.cards.startSell')
                  }
                  handleClickHelpLink={() => setShowModal(true)}
                  InformationAmountCardTextNoSales={
                    !isSeller() ? (
                      <Trans i18nKey="homeScreen.cards.nextSell" />
                    ) : (
                      t('homeScreen.cards.noSales')
                    )
                  }
                  InformationAmountCardTextError={t('homeScreen.cards.notAvaliable')}
                  merchantOn
                  loadedAmounts={loadedAmounts}
                />
              )}

              <AmountCard
                htmlIdTooltip="home-tooltip-balance-to-be-liquidated"
                amount={errAllBalances ? 'error' : moneyFormat(settledIncome, false)}
                handleClick={() => setShowTooltipModal2(true)}
                link={t('homeScreen.acelerationCard.pending.link')}
                title={t('homeScreen.acelerationCard.pending.title')}
                tooltipText={
                  isSeller() || isAlianzaMixto()
                    ? t('tooltipCards.sellerHomeSalesToLiquidate')
                    : t('tooltipCards.merchantHomeSalesToLiquidate')
                }
                to={SETTLEMENT_CALENDAR}
                InformationAmountCardTextError={t('homeScreen.cards.notAvaliable')}
                htmlIdLink="home-balance-to-be-liquidated-see-calendar"
                helpLink={t('homeScreen.acelerationCard.helpLink')}
                handleClickHelpLink={() => displayAdvancementModal()}
                showHelpLink={shouldShowAdvancementHelpLink()}
                htmlIdShowHelpLink={shouldShowAdvancementHelpLink() && 'advance-btn'}
                loadedAmounts={loadedAmounts}
              />

              <AmountCard
                htmlIdTooltip="home-tooltip-available-balance"
                amount={errMerchant ? 'error' : moneyFormat(availableIncome, false)}
                handleClick={() => {
                  setShowTooltipModal3(true);
                }}
                link={isFondsOutEnabled && t('homeScreen.totalBalance.link')}
                htmlIdLink="withdraw-money"
                to={FUNDS_OUT}
                title={t('homeScreen.totalBalance.title')}
                tooltipText={
                  isBlocked('FUNDS_OUT')
                    ? t('homeScreen.totalBalance.block.description')
                    : isSeller() || isAlianzaMixto()
                    ? t('tooltipCards.sellerHomeBalanceAvailable')
                    : t('tooltipCards.merchantHomeBalanceAvailable')
                }
                InformationAmountCardTextError={t('homeScreen.cards.notAvaliable')}
                isBlock={blockingsAllowed && isBlocked('FUNDS_OUT')}
                loadedAmounts={loadedAmounts}
              />
            </Cards>

            <LastMovements>{t('homeScreen.homeScreenTitles.ultimosMovimientos')}</LastMovements>
            {errorLastMovements ? (
              <ErrorTableLastMovements />
            ) : items?.length === 0 ? (
              <NotFoundLastMovements />
            ) : (
              <>
                <LayoutTable>
                  <OperationTable
                    dataHeader={operationHeader}
                    dataBody={items}
                    properity={[{}, {}, {}, { flex: 'flex' }, { align: 'right' }]}
                    limit={5}
                    setIdToShow={setIdToShow}
                    shouldGetFutureTransactions={false}
                    setTransactionIdToShow={setTransactionIdToShow}
                  />
                </LayoutTable>
                <Link to={LAST_MOVEMENTS}>
                  <ButtonSeeAll id="home-balance-movements-see-all" type="outlined">
                    {t('common.seeAll')}
                  </ButtonSeeAll>
                </Link>
              </>
            )}
            {showModal && (
              <Modal fClose={toggleShowModal} showCloseButton={false} width="344px">
                <ModalToFsc
                  text={t('homeScreen.cards.text')}
                  handleConfirm={
                    !isSeller()
                      ? () =>
                          window.open(
                            t('homeScreen.modalToFsc.linkToRegister'),
                            '_blank',
                            'noopener'
                          )
                      : () =>
                          window.open(t('homeScreen.modalToFsc.linkToFSC'), '_blank', 'noopener')
                  }
                  handleCancel={() => setShowModal(false)}
                  textConfirm={t('homeScreen.modalToFsc.textConfirm')}
                  textCancel={t('homeScreen.modalToFsc.textCancel')}
                />
              </Modal>
            )}
            {showTooltipModal && (
              <Modal fClose={toggleModal}>
                <TextModal>
                  {!isSeller() || salesInProgress === 0
                    ? t('homeScreen.cards.invitation')
                    : t('homeScreen.salesCard.description')}
                </TextModal>
              </Modal>
            )}
            {showTooltipModal2 && (
              <Modal fClose={toggleModal2}>
                <TextModal>{t('homeScreen.cards.toLiquidateHS')}</TextModal>
              </Modal>
            )}
            {showTooltipModal3 && (
              <Modal fClose={toggleModal3}>
                <TextModal>{t('homeScreen.totalBalance.description')}</TextModal>
              </Modal>
            )}
            {showModalPopUpTable && (
              <ModalLastMovementsTable
                open={showModalPopUpTable}
                onClose={toggleModalPopUpTable}
                idToShow={idToShow}
                breakpoint={breakpoint}
                getFondsOutByAuthorization={getFondsOutByAuthorization}
              />
            )}
            {showModalToRedirect && (
              <Modal fClose={toggleShowModalToRedirect} showCloseButton={false} width="400px">
                <ModalToRedirect
                  text={t('homeScreen.modalToBank.subTitle')}
                  link={t('homeScreen.modalToBank.linkToBank')}
                  handleCancel={() => setShowModalToRedirect(false)}
                  textConfirm={t('homeScreen.modalToBank.textConfirm')}
                  textCancel={t('homeScreen.modalToBank.textCancel')}
                />
              </Modal>
            )}
            {showAdvancementModal && (
              <Modal
                htmlIdBackground={getIdBackground()}
                showCloseButton={false}
                fClose={toggleShowAdvancementModal}
                width={breakpoint === 'xs' ? '343px' : '504px'}
                paddingLeft="0"
                paddingRight="0"
              >
                <AdvancementModal
                  handleCancel={() => toggleShowAdvancementModal()}
                  liquidationAmount={settledIncome}
                />
              </Modal>
            )}
            {showSellerBlockModal && (
              <BlockedSellerModal
                fClose={toggleShowSellerBlockModal}
                fnConfirm={setConfirmationBlockUnderstanding}
              />
            )}
          </Home>
        </LayoutGral>
      )}
    </>
  );
};

export default HomeScreen;
